// Shared by the editor iframe and generated learner HTML.
export const COLUMNS_STYLES = `
.lesson-columns { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:1rem; align-items:stretch; width:100%; min-width:0; box-sizing:border-box; margin:1rem 0; }
.lesson-columns[data-columns="3"] { grid-template-columns:repeat(3,minmax(0,1fr)); }
.lesson-columns > .lesson-column { min-width:0; overflow-wrap:anywhere; }
.lesson-column > :first-child { margin-top:0; }
.lesson-column > :last-child { margin-bottom:0; }
.lesson-column img, .lesson-column video, .lesson-column iframe { max-width:100%; }
.lesson-column figure { max-width:100%; margin-inline:0; }
.ProseMirror .lesson-columns > .lesson-column { outline:1px dashed var(--surface-border,#94a3b8); outline-offset:3px; }
.ProseMirror .lesson-columns > .lesson-column:focus-within { outline-color:var(--primary-color,#64748b); }
@media(max-width:640px) {
  .lesson-columns, .lesson-columns[data-columns="3"] { grid-template-columns:minmax(0,1fr); }
}
`;
